module.exports = __webpack_public_path__ + "img/ic_ageyear.dc22136c.svg";